const Plans = {
  FREE: 'free',
  STARTER: 'flexible',
  PREMIUM: 'premium',
  LAUNCH: 'launch',
  SCALE: 'scale',
  UNLIMITED: 'unlimited',
};

export default Plans;
